import { Grid, Segment, Header, Image as Img, Message, Label } from "semantic-ui-react";
import React from "react";
import RadioButtons from "components/Form/RadioButtons";

import { Formik, Form } from "formik";

const EndoTest = ({ endoAnswers, disabled, submit }) => {
	return (
		<div>
			<Grid.Row columns={1} style={{ margin: -20 }}>
				<Grid.Column>
					<Formik
						enableReinitialize
						initialValues={{
							cleanHands:
								!endoAnswers || endoAnswers.cleanHands === null ? "" : endoAnswers && endoAnswers.cleanHands ? "ycleanHands" : "ncleanHands",
							noInfectionSigns:
								!endoAnswers || endoAnswers.noInfectionSigns === null
									? ""
									: endoAnswers && endoAnswers.noInfectionSigns
									? "ynoInfectionSigns"
									: "nnoInfectionSigns",
							noEating: !endoAnswers || endoAnswers.noEating === null ? "" : endoAnswers && endoAnswers.noEating ? "ynoEating" : "nnoEating",
							noDrinking:
								!endoAnswers || endoAnswers.noDrinking === null ? "" : endoAnswers && endoAnswers.noDrinking ? "ynoDrinking" : "nnoDrinking",
							noSmoking: !endoAnswers || endoAnswers.noSmoking === null ? "" : endoAnswers && endoAnswers.noSmoking ? "ynoSmoking" : "nnoSmoking",
							noChewingGum:
								!endoAnswers || endoAnswers.noChewingGum === null ? "" : endoAnswers && endoAnswers.noChewingGum ? "ynoChewingGum" : "nnoChewingGum",
							noTeethBrushing:
								!endoAnswers || endoAnswers.noTeethBrushing === null
									? ""
									: endoAnswers && endoAnswers.noTeethBrushing
									? "ynoTeethBrushing"
									: "nnoTeethBrushing",
							noLipStick:
								!endoAnswers || endoAnswers.noLipStick === null ? "" : endoAnswers && endoAnswers.noLipStick ? "ynoLipStick" : "nnoLipStick",
							conform: !endoAnswers || endoAnswers.conform === null ? "" : endoAnswers && endoAnswers.conform ? "yconform" : "nconform",
							noPregnant:
								!endoAnswers || endoAnswers.noPregnant === null ? "" : endoAnswers && endoAnswers.noPregnant ? "ynoPregnant" : "nnoPregnant",
							noCancer: !endoAnswers || endoAnswers.noCancer === null ? "" : endoAnswers && endoAnswers.noCancer ? "ynoCancer" : "nnoCancer",
							noVIH: !endoAnswers || endoAnswers.noVIH === null ? "" : endoAnswers && endoAnswers.noVIH ? "ynoVIH" : "nnoVIH",
						}}
						onSubmit={(values, { setSubmitting }) => {
							let infos = { ...values };
							infos.cleanHands = values.cleanHands === "ycleanHands";
							infos.noInfectionSigns = values.noInfectionSigns === "ynoInfectionSigns";
							infos.noEating = values.noEating === "ynoEating";
							infos.noDrinking = values.noDrinking === "ynoDrinking";
							infos.noSmoking = values.noSmoking === "ynoSmoking";
							infos.noChewingGum = values.noChewingGum === "ynoChewingGum";
							infos.noTeethBrushing = values.noTeethBrushing === "ynoTeethBrushing";
							infos.noLipStick = values.noLipStick === "ynoLipStick";
							infos.conform = values.conform === "yconform";
							infos.noPregnant = values.noPregnant === "ynoPregnant";
							infos.noCancer = values.noCancer === "ynoCancer";
							infos.noVIH = values.noVIH === "ynoVIH";
							submit(infos, setSubmitting);
						}}
					>
						{({ submitForm, dirty, errors, values, touched }) => {
							return (
								<Form>
									<Segment>
										<Header as="h3" textAlign="left">
											Conditions à respecter avant le recueil de salive
										</Header>
										<fieldset
											onMouseLeave={() => {
												if (dirty) {
													submitForm();
												}
											}}
										>
											<Grid>
												<Grid.Row columns={3}>
													<Grid.Column>
														<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "4px" }}>
															<Img
																src={window.location.origin + "/icones/endo-ico/cleanHands.png"}
																width="70"
																height="50"
																style={{ paddingRight: "20px" }}
															/>
															<RadioButtons
																name="cleanHands"
																field1={{ id: "ycleanHands", customlabel: "OK" }}
																field2={{ id: "ncleanHands", customlabel: "Non" }}
																customlabel={<span>S'être lavé les mains juste avant le reccueil</span>}
																errors={errors}
																touched={touched}
																required
																disabled={disabled}
																fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 8px" }}
															/>
														</div>
													</Grid.Column>
													<Grid.Column>
														<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "4px" }}>
															<Img
																src={window.location.origin + "/icones/endo-ico/noInfectionSigns.png"}
																width="70"
																height="50"
																style={{ paddingRight: "20px" }}
															/>
															<RadioButtons
																name="noInfectionSigns"
																field1={{ id: "ynoInfectionSigns", customlabel: "OK" }}
																field2={{ id: "nnoInfectionSigns", customlabel: "Non" }}
																customlabel={<span>Ne pas présenter de signes d'infection</span>}
																errors={errors}
																touched={touched}
																required
																disabled={disabled}
																fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 8px" }}
															/>
														</div>
													</Grid.Column>
												</Grid.Row>
												<Grid.Row columns={3}>
													<Grid.Column>
														<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "4px" }}>
															<Img
																src={window.location.origin + "/icones/endo-ico/noPregnant.png"}
																width="70"
																height="50"
																style={{ paddingRight: "20px" }}
															/>
															<RadioButtons
																name="noPregnant"
																field1={{ id: "ynoPregnant", customlabel: "OK" }}
																field2={{ id: "nnoPregnant", customlabel: "Non" }}
																customlabel={<span>Ne pas avoir de grossesse en cours</span>}
																errors={errors}
																touched={touched}
																required
																disabled={disabled}
																fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 8px" }}
															/>
														</div>
													</Grid.Column>
													<Grid.Column>
														<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "4px" }}>
															<Img
																src={window.location.origin + "/icones/endo-ico/noVIH.png"}
																width="70"
																height="50"
																style={{ paddingRight: "20px" }}
															/>
															<RadioButtons
																name="noVIH"
																field1={{ id: "ynoVIH", customlabel: "OK" }}
																field2={{ id: "nnoVIH", customlabel: "Non" }}
																customlabel={<span>Ne pas être infecté à VIH</span>}
																errors={errors}
																touched={touched}
																required
																disabled={disabled}
																fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 8px" }}
															/>
														</div>
													</Grid.Column>
													<Grid.Column>
														<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "4px" }}>
															<Img
																src={window.location.origin + "/icones/endo-ico/noCancer.png"}
																width="70"
																height="50"
																style={{ paddingRight: "20px" }}
															/>
															<RadioButtons
																name="noCancer"
																field1={{ id: "ynoCancer", customlabel: "OK" }}
																field2={{ id: "nnoCancer", customlabel: "Non" }}
																customlabel={<span>Ne pas avoir d'antécédants de cancer</span>}
																errors={errors}
																touched={touched}
																required
																disabled={disabled}
																fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 8px" }}
															/>
														</div>
													</Grid.Column>
												</Grid.Row>
												<Grid.Row columns={1}>
													<Grid.Column>
														<b>30 minutes avant le prélèvement :</b>
													</Grid.Column>
												</Grid.Row>
												<Grid.Row columns={3}>
													<Grid.Column>
														<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "4px" }}>
															<Img
																src={window.location.origin + "/icones/endo-ico/noEatingNorDrinking.png"}
																width="70"
																height="50"
																style={{ paddingRight: "20px" }}
															/>
															<RadioButtons
																name="noDrinking"
																field1={{ id: "ynoDrinking", customlabel: "OK" }}
																field2={{ id: "nnoDrinking", customlabel: "Non" }}
																customlabel={<span>Ne pas avoir bu</span>}
																errors={errors}
																touched={touched}
																required
																disabled={disabled}
																fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 8px" }}
															/>
														</div>
													</Grid.Column>
													<Grid.Column>
														<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "4px" }}>
															<Img
																src={window.location.origin + "/icones/endo-ico/noEating.png"}
																width="70"
																height="50"
																style={{ paddingRight: "20px" }}
															/>
															<RadioButtons
																name="noEating"
																field1={{ id: "ynoEating", customlabel: "OK" }}
																field2={{ id: "nnoEating", customlabel: "Non" }}
																customlabel={<span>Ne pas avoir mangé</span>}
																errors={errors}
																touched={touched}
																required
																disabled={disabled}
																fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 8px" }}
															/>
														</div>
													</Grid.Column>
													<Grid.Column>
														<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "4px" }}>
															<Img
																src={window.location.origin + "/icones/endo-ico/noSmoking.png"}
																width="70"
																height="50"
																style={{ paddingRight: "20px" }}
															/>
															<RadioButtons
																name="noSmoking"
																field1={{ id: "ynoSmoking", customlabel: "OK" }}
																field2={{ id: "nnoSmoking", customlabel: "Non" }}
																customlabel={<span>Ne pas avoir fumé </span>}
																errors={errors}
																touched={touched}
																required
																disabled={disabled}
																fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 8px" }}
															/>
														</div>
													</Grid.Column>
												</Grid.Row>
												<Grid.Row columns={3}>
													<Grid.Column>
														<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "4px" }}>
															<Img
																src={window.location.origin + "/icones/endo-ico/noChewingGum.png"}
																width="70"
																height="50"
																style={{ paddingRight: "20px" }}
															/>
															<RadioButtons
																name="noChewingGum"
																field1={{ id: "ynoChewingGum", customlabel: "OK" }}
																field2={{ id: "nnoChewingGum", customlabel: "Non" }}
																customlabel={<span>Ne pas avoir mâché du chewing-gum </span>}
																errors={errors}
																touched={touched}
																required
																disabled={disabled}
																fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 8px" }}
															/>
														</div>
													</Grid.Column>
													<Grid.Column>
														<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "4px" }}>
															<Img
																src={window.location.origin + "/icones/endo-ico/noLipStick.png"}
																width="70"
																height="50"
																style={{ paddingRight: "20px" }}
															/>
															<RadioButtons
																name="noLipStick"
																field1={{ id: "ynoLipStick", customlabel: "OK" }}
																field2={{ id: "nnoLipStick", customlabel: "Non" }}
																customlabel={<span>Ne pas avoir porté de rouge à lèvres </span>}
																errors={errors}
																touched={touched}
																required
																disabled={disabled}
																fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 8px" }}
															/>
														</div>
													</Grid.Column>
													<Grid.Column>
														<div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "4px" }}>
															<Img
																src={window.location.origin + "/icones/endo-ico/noTeethBrushing.png"}
																width="70"
																height="50"
																style={{ paddingRight: "20px" }}
															/>
															<RadioButtons
																name="noTeethBrushing"
																field1={{ id: "ynoTeethBrushing", customlabel: "OK" }}
																field2={{ id: "nnoTeethBrushing", customlabel: "Non" }}
																customlabel={<span>Ne pas s'être brossé les dents</span>}
																errors={errors}
																touched={touched}
																required
																disabled={disabled}
																fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 8px" }}
															/>
														</div>
													</Grid.Column>
												</Grid.Row>
											</Grid>
										</fieldset>
										<div
											style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", padding: "20px", flexWrap: "wrap" }}
										></div>
									</Segment>
									<Segment>
										<Header as="h3" textAlign="left">
											Réalisation du prélèvement
										</Header>
										<Grid>
											<Grid.Row>
												<Grid.Column width={3}>
													<Img src={window.location.origin + "/icones/endo-ico/kit.png"} />
												</Grid.Column>
												<Grid.Column width={3}>
													<div style={{ border: "5px dashed teal", borderRadius: "30px", padding: "15px" }}>
														Vissez l’entonnoir puis faites cracher la patiente pour obtenir un volume dépassant de 1 cm le trait plein présent sur le
														tube (la limite correspond au pictogramme « usine », ligne orange sur l’image.)
													</div>
												</Grid.Column>
												<Grid.Column width={10}>
													<Img src={window.location.origin + "/icones/endo-ico/confirm.png"} />
													En cas de volume insuffisant, demandez à la patiente de compléter le recueil.
													<fieldset
														onMouseLeave={() => {
															if (dirty) {
																submitForm();
															}
														}}
													>
														<RadioButtons
															name="conform"
															field1={{ id: "yconform", customlabel: "Oui" }}
															field2={{ id: "nconform", customlabel: "Non" }}
															customlabel={<span>L'échantillon est-il conforme ?</span>}
															errors={errors}
															touched={touched}
															required
															disabled={disabled}
															fieldStyle={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", padding: "0 10px" }}
														/>
													</fieldset>
												</Grid.Column>
											</Grid.Row>
										</Grid>
									</Segment>
									<Segment>
										<Header as="h3" textAlign="left">
											Pré-traitement de l'échantillon
										</Header>

										<Grid>
											<Grid.Row columns={5}>
												<Grid.Column>
													<Img src={window.location.origin + "/icones/endo-ico/step2.png"} />
												</Grid.Column>
												<Grid.Column>
													<div style={{ border: "5px dashed teal", borderRadius: "30px", padding: "15px" }}>
														Tenez le tube verticalement d'une main. Fermez le couvercle de l'entonnoir avec votre autre main en appuyant fermement sur
														le couvercle jusqu'à ce que vous entendiez un déclic.
													</div>
												</Grid.Column>
												<Grid.Column>
													<Img src={window.location.origin + "/icones/endo-ico/clic.png"} />
												</Grid.Column>
												<Grid.Column>
													<div style={{ border: "5px dashed teal", borderRadius: "30px", padding: "15px" }}>
														Assurez-vous que le couvercle est bien fermé. Le liquide contenu dans le couvercle sera libéré dans le tube pour se
														mélanger à l'échantillon.
													</div>
												</Grid.Column>
												<Grid.Column>
													<Img src={window.location.origin + "/icones/endo-ico/liquid.png"} />
												</Grid.Column>
											</Grid.Row>
											<Grid.Row columns={5}>
												<Grid.Column>
													<Img src={window.location.origin + "/icones/endo-ico/step3.png"} />
												</Grid.Column>
												<Grid.Column>
													<div style={{ border: "5px dashed teal", borderRadius: "30px", padding: "15px" }}>
														Tenez le tube verticalement. Dévissez l'entonnoir du tube.
													</div>
												</Grid.Column>
												<Grid.Column></Grid.Column>
												<Grid.Column></Grid.Column>
												<Grid.Column></Grid.Column>
											</Grid.Row>
											<Grid.Row columns={5}>
												<Grid.Column>
													<Img src={window.location.origin + "/icones/endo-ico/step4.png"} />
												</Grid.Column>
												<Grid.Column>
													<div style={{ border: "5px dashed teal", borderRadius: "30px", padding: "15px" }}>
														Utilisez le bouchon pour fermer le tube.
													</div>
												</Grid.Column>
												<Grid.Column></Grid.Column>
												<Grid.Column></Grid.Column>
												<Grid.Column></Grid.Column>
											</Grid.Row>
											<Grid.Row columns={5}>
												<Grid.Column>
													<Img src={window.location.origin + "/icones/endo-ico/step5.png"} />
												</Grid.Column>
												<Grid.Column>
													<div style={{ border: "5px dashed teal", borderRadius: "30px", padding: "15px" }}>
														Homogénéisez le tube bouché pendant 5 secondes.
													</div>
												</Grid.Column>
												<Grid.Column>
													<Img src={window.location.origin + "/icones/endo-ico/discard.png"} />
												</Grid.Column>
												<Grid.Column>
													<div style={{ border: "5px dashed teal", borderRadius: "30px", padding: "15px" }}>Jetez l'entonnoir dans un DASRI.</div>
												</Grid.Column>
												<Grid.Column></Grid.Column>
											</Grid.Row>
										</Grid>
									</Segment>
								</Form>
							);
						}}
					</Formik>
				</Grid.Column>
			</Grid.Row>
		</div>
	);
};

export default EndoTest;
